import { apiClient } from 'shared/api';

export const getNotificationCheck = async (): Promise<boolean> => {
  const { data } = await apiClient.get('/member/notification/check');
  return data.result;
};
